import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import OperationalChange from './OperationalChange'
import Details from './Details'

const OperationalIndex = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/details'} component={Details} />
      <CacheRoute component={OperationalChange} />
    </CacheSwitch>
  )
}

export default OperationalIndex
